import { render } from "./Player.vue?vue&type=template&id=83ef679c"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
script.render = render

export default script